import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faChartBar, faTags } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';

const Sidebar = ({ height, pageChannel }) => {
  const history = useHistory();

  return (
    <div style={{ height: height }} className="col-xl-2 d-xl-block d-none side-nav pt-3">
      <a
        onClick={() => history.push({ pathname: '/', state: { pageChannel: pageChannel } })}
        style={{ cursor: 'pointer' }}
      >
        <div>
          <FontAwesomeIcon style={{ marginRight: 10 }} icon={faHome} />
          Overview
        </div>
      </a>
      <a
        onClick={() => history.push({ pathname: '/insights', state: { pageChannel: pageChannel } })}
        style={{ cursor: 'pointer' }}
      >
        <div>
          <FontAwesomeIcon style={{ marginRight: 10 }} icon={faHome} />
          Insights
        </div>
      </a>
      <a
        onClick={() => history.push({ pathname: '/marketprice-db', state: { pageChannel: pageChannel } })}
        style={{ cursor: 'pointer' }}
      >
        <div>
          <FontAwesomeIcon style={{ marginRight: 10 }} icon={faTags} />
          Market Price DB
        </div>
      </a>
    </div>
  );
};

export default Sidebar;
